import React from 'react'
import { withNamespaces } from '@edulastic/localization'
import { DivBlock } from '../SimpleOptions/styled'
import StandardProficiencyTable from '../../../TestPage/components/Setting/components/Container/StandardProficiencyTable'
import PerformanceBand from '../../../TestPage/components/Setting/components/Container/PerformanceBand'
import DetailsTooltip from './DetailsTooltip'
import SettingContainer from './SettingsContainer'

const MiscellaneousGroupContainer = ({
  assignmentSettings,
  testSettings,
  freezeSettings,
  overRideSettings,
  featuresAvailable,
  tootltipWidth,
  premium,
}) => {
  const {
    performanceBand = testSettings.performanceBand,
    standardGradingScale = testSettings.standardGradingScale,
  } = assignmentSettings

  const { performanceBands } = featuresAvailable

  return (
    <>
      {/* Performance Bands */}
      <SettingContainer
        id="performance-bands-setting"
        tooltipId="performance-bands-setting-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="Performance Bands"
          content="Performance bands are set by district or school admins. Teachers can choose from the different profiles created by the admin."
          premium={performanceBands}
          placement="rightBottom"
          id="performance-bands-setting-tooltip"
        />
        <DivBlock>
          <PerformanceBand
            disabled={freezeSettings || !performanceBands}
            setSettingsData={(val) => overRideSettings('performanceBand', val)}
            performanceBand={performanceBand || {}}
            isFeatureAvailable={performanceBands}
            fromAssignments
          />
        </DivBlock>
      </SettingContainer>
      {/* Performance Bands */}

      {/* Standards Based Grading Scale */}
      <SettingContainer
        id="standards-mastery-setting"
        tooltipId="standards-mastery-setting-tooltip"
      >
        <DetailsTooltip
          width={tootltipWidth}
          title="Standards Based Grading Scale"
          content="Standards based scales are set by district or school admins. Teachers can choose from the different profiles created by the admin."
          premium={premium}
          placement="rightBottom"
          fromAssignments
          id="standards-mastery-setting-tooltip"
        />
        <DivBlock>
          <StandardProficiencyTable
            disabled={freezeSettings || !premium}
            standardGradingScale={standardGradingScale || {}}
            setSettingsData={(val) =>
              overRideSettings('standardGradingScale', val)
            }
            isFeatureAvailable={premium}
            fromAssignments
          />
        </DivBlock>
      </SettingContainer>
      {/* Standards Based Grading Scale */}
    </>
  )
}

export default withNamespaces('author')(MiscellaneousGroupContainer)
